




































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { mapState } from 'vuex';
import _ from 'lodash';
import { v4 as uuidv4 } from 'uuid';
import showFilesModal from '../components/showFiles.vue';
import { Spinner } from 'vue-image-spinner2';
import { Debounce } from 'vue-debounce-decorator';

@Component({
    name: 'subtitle-catalogs',
    components: {
        showFilesModal,
        Spinner,
    },
    computed: {
        ...mapState('catalogs', ['activeCatalogLoading', 'activeCatalog']),
        ...mapState('auth', ['currentUser']),
        ...mapState('products', ['cacheProducts', 'cacheProductsLoading']),
    },
})
export default class SubtitleCatalogs extends Vue {
    //
    private activeCatalog!: any;
    private searchQuery: string = '';
    private currentUser!: any;
    private producto_actualizado!: any;

    canSee(roles: any) {
        return _.intersection(roles, [this.currentUser.role.name]).length > 0;
    }

    onAddProduct(parent: any) {
        parent.products.push({
            new: true,
        });
    }

    onSetProduct(product: any, parent: any, index: number) {
        console.log('productos', product);
       // this.producto_actualizado = product;

        parent.products.splice(index, 1);
        parent.products.push({
            new: false,
            qty: 1,
            id: product.id,
            id_new: product.id_new,
            name: product.name, 
            slug: product.slug,
        });

        

        this.activeCatalog.products.forEach((item: any) => {
            if (item.id == product.id) {
                item.image[0].url = `https://directus.prodelec.app/assets/${item.image[0].id}`;
                this.activeCatalog.image.unshift(item.image[0]);
            }
        });
    }

    onSetSubtitle(sub: any, parent: any, index: number) {
        parent.subtitle.splice(index, 1);
        parent.subtitle.push({
            new: false,
            subtitle: sub,
            products: [],
        });
    }

    @Watch('searchQuery')
    @Debounce(600)
    updateProductsList(search: string) {
        if (/\s/.test(this.searchQuery)) {
            const finalSentence = this.searchQuery.replace(/(^\w{1})|(\s+\w{1})/g, (letter) => letter.toUpperCase());
            this.searchQuery = finalSentence;
        } else {
            this.searchQuery = this.searchQuery.toUpperCase();
        }

        if (this.searchQuery.length > 1 && this.searchQuery.trim() != '') {
            this.$store.dispatch('products/cacheAll', { search, limit: 40 });
        }
    }

    getProductUrl(id: string) {
        return `https://www.prodelec.app/#/products?search=${id}&page=1`; // redirect to app.prodelec.mx
    }

    onRemoveProduct(parent: any, index: any, product: any) {
        parent.products.splice(index, 1);
    }

    onRemoveSubtitle(parent: any, index: any, sub: any) {
        parent.subtitle.splice(index, 1);
    }
}
